export default "__VITE_ASSET__C9cfgItD__"